module.exports = "<template>\n<div id=\"sio-paticipants-list\"></div>\n</template>";